import React from 'react';

interface StylizedDividerProps {
  className?: string;
  showDot?: boolean;
}

const StylizedDivider: React.FC<StylizedDividerProps> = ({ className = '', showDot = true }) => {
  return (
    <div className={`relative py-12 ${className}`}>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-full max-w-4xl mx-auto px-8">
          <div className="h-1.5 bg-gradient-to-r from-transparent via-delphi-red to-transparent rounded-full shadow-[0_0_20px_rgba(234,56,76,0.5),0_0_40px_rgba(234,56,76,0.3)]" />
        </div>
      </div>
      {showDot && (
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-3 h-3 bg-delphi-red rounded-full shadow-[0_0_15px_rgba(234,56,76,0.8),0_0_30px_rgba(234,56,76,0.5)]" />
        </div>
      )}
    </div>
  );
};

export default StylizedDivider;
